import React from 'react';
import { KIND } from '../../constants';
import TimelineSection from './TimelineSection';
import FamilySection from './FamilySection';
import NotesSection from './NotesSection';

const e = React.createElement;

const BODIES = {
  [KIND.TIMELINE]: TimelineSection,
  [KIND.FAMILY]: FamilySection,
  [KIND.NOTES]: NotesSection,
};

/**
 * Renders the section the payload put in front of us: its own title and copy,
 * then the body for its kind. The order the sections come in, and whether one
 * is optional, stay the server's business.
 */
const Section = ({ section, isPhone, footer }) => {
  if (!section) return null;
  // A kind this build does not know renders as its plain fields rather than as
  // nothing at all, so a new server section is never a blank screen.
  const Body = BODIES[section.kind || section.key] || NotesSection;

  return e('div', { className: 'wd-wrap' }, [
    e('h1', { className: 'wd-sec', key: 'title' }, section.title),
    e(Body, { key: 'body', section, isPhone }),
    footer,
  ]);
};

export default Section;
